import { render, staticRenderFns } from "./BaseManagement.vue?vue&type=template&id=6959502f&scoped=true&"
import script from "./BaseManagement.vue?vue&type=script&lang=js&"
export * from "./BaseManagement.vue?vue&type=script&lang=js&"
import style0 from "./BaseManagement.vue?vue&type=style&index=0&id=6959502f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959502f",
  null
  
)

export default component.exports